module.exports = __webpack_public_path__ + "img/account-circle.88ddb4d7.png";